import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'b', 'strong', 'em', 'i', 'u', 'del', 'strike', 'ins',
  'ul', 'ol', 'li', 'p', 'h1', 'h2', 'pre', 'span', 'a', 'br',
];

const ALLOWED_ATTR = ['href', 'target', 'rel', 'style'];

// Block CSS properties that can execute code
const SAFE_CSS_PROPS = /^(color|background-color|font-size|font-family|text-align|font-weight|font-style|text-decoration)$/i;
const DANGEROUS_CSS_VALUE = /javascript:|expression\s*\(|url\s*\(|@import|behavior\s*:/i;

const sanitizeStyleAttr = (node) => {
  if (!node.style) return;
  const toRemove = [];
  for (const prop of node.style) {
    const value = node.style.getPropertyValue(prop);
    if (!SAFE_CSS_PROPS.test(prop) || DANGEROUS_CSS_VALUE.test(value)) {
      toRemove.push(prop);
    }
  }
  toRemove.forEach(p => node.style.removeProperty(p));
};

DOMPurify.addHook('afterSanitizeAttributes', sanitizeStyleAttr);

export const sanitizeInput = (input) => {
  if (!input) return '';
  return DOMPurify.sanitize(input, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
};

export const sanitizeHtml = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORCE_BODY: true,
  });
};
